export const isCypress = () => {
  return localStorage.cypress === 'true'
}
